import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {Menu} from 'semantic-ui-react'

class NavLink extends React.Component {
    render() {
        const isActive = this.context.router.route.location.pathname === this.props.to;
        return(
            <Menu.Item as={Link} active={isActive} to={this.props.to}>{this.props.children}</Menu.Item>
        );
    }
}

NavLink.contextTypes = {
    router: PropTypes.object
};

export default NavLink;


// WEBPACK FOOTER //
// ./src/components/NavLink/index.js